import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { takeUntil } from 'rxjs';
import { TuiButtonOptions, TuiDialogContext, TuiDialogService } from '@taiga-ui/core';
import { PolymorpheusContent } from '@taiga-ui/polymorpheus';
import { BaseComponent } from '@src/app/modules/base';

import { ReportType } from '../types';
import { ReportsService } from '../services';

@Component({
  selector: 'app-reports-button',
  templateUrl: './reports-button.component.html',
  styleUrls: ['./reports-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportsButtonComponent extends BaseComponent implements OnInit {
  private readonly dialogService = inject(TuiDialogService);
  private readonly reportsService = inject(ReportsService);

  @Input() size: TuiButtonOptions['size'] = 'm';
  @Input() reportType?: ReportType;
  @Input() hiddenReportData?: Object;

  visible = false;

  ngOnInit(): void {
    if (this.reportType) {
      this.reportsService
        .getReports(this.reportType)
        .pipe(takeUntil(this.destroyed$$))
        .subscribe(reports => {
          this.visible = !!reports.length;
          this.cdr.markForCheck();
        });
    }
  }

  showReportsDialog(content: PolymorpheusContent<TuiDialogContext>) {
    this.dialogService.open(content).subscribe();
  }
}
